import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLucky6Access } from 'hooks/useLucky6Access';
import styles from './LuckySixHome.module.css';

// Ball colours of the game, for the card's decoration.
const BALLS = [
  ['#e8403b', 7],
  ['#2fa84f', 18],
  ['#2b6fe0', 23],
  ['#8e3fc4', 31],
  ['#f39a1e', 39],
  ['#d9b400', 44],
] as const;

/** Modern home: the way into Lucky Six, for players it is switched on for. */
export const LuckySixHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const enabled = useLucky6Access();
  if (!enabled) return null;
  return (
    <>
      <div className={styles.head}>
        <h2>{t('lucky_six_label')}</h2>
      </div>
      <button
        type="button"
        className={styles.card}
        onClick={() => navigate('/lucky-six')}
      >
        <span className={styles.logo}>
          LUCKY <b>6</b>
        </span>
        <span className={styles.sub}>{t('lucky_six_home_sub')}</span>
        <span className={styles.balls} aria-hidden>
          {BALLS.map(([c, n]) => (
            <i key={n} style={{ background: c }}>
              {n}
            </i>
          ))}
        </span>
        <span className={styles.play}>{t('lucky_six_play')}</span>
      </button>
    </>
  );
};
